<template>
  <div
    v-if="loading"
    class="content"
  >
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div
    v-else
    class="content"
  >
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <nav-tabs-card>
          <template slot="content">
            <!-- <span  @click="csvExport( )">Export CSV </span> -->

            <md-tabs
              md-sync-route
              class="md-success"
              md-alignment="left"
              :md-selected="selectedIndex"
            >
              <md-tab
                v-for="consumableitem in consumableitems"
                :id="consumableitem.type"
                :key="consumableitem.type"
                :md-label="consumableitem.type"
              >
                <md-table
                  v-model="consumableitem.list"
                  table-header-color="gray"
                  @md-selected="onSelectOpen"
                >
                  <md-table-row
                    v-if="item.new<item.min"
                    slot="md-table-row"
                    slot-scope="{ item }"
                    :class="getClass(item)"
                    md-selectable="single"
                    style="color:red;"
                  >
                    <md-table-cell md-label="Nome">
                      {{ item.name }}
                    </md-table-cell>
                    <md-table-cell md-label="Fab">
                      {{ item.fab }}
                    </md-table-cell>
                    <md-table-cell md-label="Quant.">
                      {{ item.new }}/{{ item.min }}
                    </md-table-cell>
                  </md-table-row>

                  <md-table-row
                    v-else
                    slot="md-table-row"
                    slot-scope="{ item }"
                    :class="getClass(item)"
                    md-selectable="single"
                  >
                    <md-table-cell md-label="Nome">
                      {{ item.name }}
                    </md-table-cell>
                    <md-table-cell md-label="Fab">
                      {{ item.fab }}
                    </md-table-cell>
                    <md-table-cell md-label="Quant.">
                      {{ item.new }}/{{ item.min }}
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <md-card-actions
                  layout="row"
                  layout-align="end center"
                >
                  <md-button
                    v-if="consumableitem.page!=1"
                    @click="minusPage(consumableitem.type)"
                  >
                    <<
                  </md-button>
                  <md-button>{{ consumableitem.page }}/{{ Math.round((consumableitem.total/10)+0.5) }}</md-button>
                  <md-button
                    v-if="consumableitem.page!=Math.round((consumableitem.total/10)+0.5)"
                    @click="plusPage(consumableitem.type)"
                  >
                    >>
                  </md-button>
                  <md-button
                    v-if="completeList.length!=0"
                    @click="csvExport()"
                  >
                    EXPORT
                  </md-button>
                  <i
                    v-if="completeList.length==0"
                    class="fa fa-spinner"
                  />
                </md-card-actions>
              </md-tab>


              <!-- <span   @click="csvExport( )"  id="export" md-label="Export CSV" >
                </span> -->
            </md-tabs>
            <!-- <button v-if="totalItems>0 && loading_info!=true"  @click="csvExport( )">Export CSV </button> -->
            <!-- <span class="md-nav-tabs-title" @click="csvExport( )">EXPORT CSV</span> -->
          </template>
        </nav-tabs-card>
      </div>
    </div>
    <div>
      <router-link :to=" '/consumableadd/' ">
        <a
          class="float"
          style="color:white;z-index: 100; overflow:hidden"
        >
          <i class="fa fa-plus my-float" />
        </a>
      </router-link>
    </div>
  </div>
</template>

<script>
import { userService } from "../_services";
import Spinner from "vue-simple-spinner";

import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable
} from "@/components";
import { getUserSession } from "../_services/localstorage";

export default {
  components: {
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable
  },
  props: ["alarms"],
  data() {
    return {
      consumableitems:[],
      CSVLabes: "ID;NOME;REFERENCIA;TIPO;FABRICANTE;QNT ITENS USADOS;QNT ITENS NOVOS;QNT TOTAL;LOCALIZACAO;QNT MINIMA;COMENTARIO;VALOR UN.(R$);LEAD TIME (DIAS);CALCULO AUTO;UNIDADE;FORNECEDOR;DATA DE INVENTARIO;CONSUMIDOS ULTIMOS 12 MESES;",

      consumableitemtype:[],
      notifications: {
        topCenter: false
      },
      oldList: [],
      alarmList: [],
      triggers:[],
      sites:[],
      alarmListPriority: "green",
      timer: "",
      listEquipments:[],
      totalEquipments:0,
      glpiActiveEntity:"",
      loading:true,
      sort: "asc",
      sortField: "clock",
      listItemsPerPage: [5, 10, 20, 50, 100, 99999],
      itemsPerPage: 10,
      listSiteFilter: [],
      siteFilter: null,
      listApplicationFilter: [],
      applicationFilter: 0,
      currentPage: 1,
      totalItems: 0,
      test:[],
      selectedIndex:"",
      user:{},
      list:[],
      completeList:[]
    };
  },
  watch: {
   alarms: {
     handler: function() {
       this.alarmList=this.alarms;
     },
     deep: true
   }
 },
  created: function() {
    this.loading = true;
    // this.equipments=Array(this.equipmentType.length).fill(0);
    this.user = getUserSession();
    this.glpiActiveEntity=this.user.activeentity;
    // this.loading=false;
    // console.log("search1");
    // console.log(this.user )
    // this.loading=true;

    // Configure Dates on CSV File
    var now = new Date();
    var swapmonth = now.getMonth();
    var swapyear = now.getFullYear();
    for (var k = 0; k < 13; k++) {
      this.CSVLabes=this.CSVLabes+= (swapmonth+1).toString()+"/"+(swapyear).toString()+";";
      swapmonth=swapmonth-1;
      if(swapmonth<0){
        swapmonth=11;
        swapyear=swapyear-1;
      }
    }
    this.CSVLabes=this.CSVLabes+="\n";
    // console.log(this.CSVLabes)





    userService.searchConsumableItemTotal(this.user.token).then(searchResult => {
      // console.log(searchResult)
      for (var k = 0; k < searchResult.list.length; k++) {
        this.completeList.push(searchResult.list[k]);
      }
      // console.log(this.completeList)
      this.loading=false;

    });


    userService.searchConsumableItemType(this.user.token).then(searchResult => {

      this.consumableitemtype=searchResult.types;
      var j = 0;
      // console.log(this.consumableitemtype)
      for (j = 0; j < this.consumableitemtype.length; j++) {

        userService.searchConsumableItemByType(this.user.token,this.consumableitemtype[j],1).then(searchResult => {

          // console.log(searchResult)
          for (var k = 0; k < searchResult.list.length; k++) {
            this.list.push(searchResult.list[k]);
          }

          for (var k = 0; k < this.consumableitemtype.length; k++) {
            if(this.consumableitemtype[k]==searchResult.type && searchResult.total>0){
              this.consumableitems.push(searchResult);

              // if(searchResult.type==this.equipmentType[0]){
              //
              // }
              // console.log(searchResult)
              this.loading=false;

            }
          }
          this.loading=false;
          // console.log(this.list)
        });
      }
    });


    this.timer = setInterval(this.checkSite, 1000);

  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    changePage: function(currentPage) {
      this.currentPage = currentPage;
      const start = (currentPage - 1) * this.itemsPerPage;
      const end = currentPage * this.itemsPerPage;
      this.data = this.events.slice(start, end);
      // console.log("load data for the new page", currentPage);
    },

    updateCurrentPage: function(currentPage) {
      this.currentPage = currentPage;
      // console.log("update current page without need to load data", currentPage);
    },
    checkSite: function () {

      // console.log("check "+this.user.activeentity+ " > "+this.glpiActiveEntity)

      this.user = getUserSession();
      // console.log(this.user);
      // this.totalTickets=this.totalTickets+1;

      if(this.user.activeentity!=this.glpiActiveEntity){
        // this.loading=true;
        // console.log("Search1");
        this.glpiActiveEntity=this.user.activeentity;
        this.loading=true;
        var j = 0;
        this.consumableitems=[];

        userService.searchConsumableItemTotal(this.user.token).then(searchResult => {
          // console.log(searchResult)
          for (var k = 0; k < searchResult.list.length; k++) {
            this.completeList.push(searchResult.list[k]);
          }
          // console.log(this.completeList)
          this.loading=false;

        });

        userService.searchConsumableItemType(this.user.token).then(searchResult => {

          this.consumableitemtype=searchResult.types;
          var j = 0;
          for (j = 0; j < this.consumableitemtype.length; j++) {

            userService.searchConsumableItemByType(this.user.token,this.consumableitemtype[j],1).then(searchResult => {
              var k=0;

              // console.log(searchResult)
              for (k = 0; k < this.consumableitemtype.length; k++) {
                if(this.consumableitemtype[k]==searchResult.type && searchResult.total>0){
                  this.consumableitems.push(searchResult);
                  // console.log(this.consumableitems)
                  this.loading=false;


                }
              }

            });
          }
        });


      }

  },
    convertDate: function (str) {
      var date = new Date(str);
      return date.toLocaleDateString();

    },
    formartEquipmentList: function (list, total, type){

      var j=0,k=0, type_id=0,swapList=[];

      // console.log(this.listEquipments)


      this.loading=false;



      // for (j = 0; j < list.data; j++) {
      //   swapList.push(
      //     {
      //       id: list.data[j][2],
      //       tag: list.data[j][6],
      //       name: list.data[j][1],
      //       fab: list.data[j][23],
      //       sn: list.data[j][5],
      //       location: list.data[j][3],
      //       model: list.data[j][40],
      //       id: list.data[j][2],
      //     }
      //   )
      // }




    },
    notifyVue(messageIn,priority) {
      this.$notify({
        message:messageIn,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: this.type[priority]
      });
    },
    loadData: function () {

    },
    plusPage: function (str) {
      var j=0;
      // this.loading=true;
      for (j = 0; j < this.consumableitems.length; j++) {
        if(this.consumableitems[j].type==str){
          this.consumableitems[j].page=this.consumableitems[j].page+1;

          userService.searchConsumableItemByType(this.user.token,this.consumableitems[j].type,this.consumableitems[j].page).then(searchResult => {
            var k=0;
            // console.log(searchResult)
            for (k = 0; k < this.consumableitems.length; k++) {
              if(this.consumableitems[k].type==searchResult.type ){
                this.loading=true;
                this.consumableitems[k]=searchResult;
                this.selectedIndex=searchResult.type;
                this.loading=false;

              }
            }

          });

        }
      }
      // console.log(this.consumableitems)
      // console.log(str)
    },
    minusPage: function (str) {
      var j=0;
      // this.loading=true;
      for (j = 0; j < this.consumableitems.length; j++) {
        if(this.consumableitems[j].type==str){
          this.consumableitems[j].page=this.consumableitems[j].page-1;

          userService.searchConsumableItemByType(this.user.token,this.consumableitems[j].type,this.consumableitems[j].page).then(searchResult => {
            var k=0;
            // console.log(searchResult)
            for (k = 0; k < this.consumableitems.length; k++) {
              if(this.consumableitems[k].type==searchResult.type ){
                this.loading=true;
                this.consumableitems[k]=searchResult;
                this.selectedIndex=searchResult.type;
                this.loading=false;

              }
            }

          });

        }
      }
      // console.log(this.consumableitems)
      // console.log(str)
    },
    cancelAutoUpdate: function() { clearInterval(this.timer); },
    onSelectOpen (item) {
        this.selected = item;
        // console.log(this.selected);
        if(this.selected.id>0){
          this.$router.push("/consumableinfo/"+this.selected.id);
        }

      },
    getClass: ({ id }) => ({
          "md-primary": id === 2,
          "md-accent": id === 3
        }),

        csvExport( ) {
          // console.log("EXPORT!!")
          // this.completeList[0]=this.CSVLabes

          let csvContent = "data:text/csv;charset=utf-8,";
          // csvContent += [
          //   Object.keys(this.completeList[0]).join(";"),
          //   ...this.completeList.map(item => Object.values(item).join(";"))
          // ]
          csvContent += this.CSVLabes
            .replace(/(^\[)|(\]$)/gm, "");
          csvContent += [
            // Object.keys(this.completeList[0]).join(";"),
            ...this.completeList.map(item => Object.values(item).join(";"))
          ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");

          // console.log(csvContent)
          const data = encodeURI(csvContent);
          const link = document.createElement("a");
          link.setAttribute("href", data);
          link.setAttribute("download", "export.csv");
          link.click();
        }
  }
};
</script>

<style>
md-table-pagination span.label { color: #757575; }

/* *{padding:0;margin:0;} */

/* body{
	font-family:Verdana, Geneva, sans-serif;
	font-size:18px;
	background-color:#CCC;
} */

.float{
	position:fixed;
	width:60px;
	height:60px;
	bottom:40px;
	right:40px;
	background-color:#0C9;
	color:#FFF;
	border-radius:50px;
	text-align:center;
	box-shadow: 2px 2px 3px #999;
}

.my-float{
	margin-top:22px;
}
</style>
